import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowHorizontalIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M10.5 19.5L3 12M3 12L10.5 4.5M3 12H21', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
//# sourceMappingURL=arrow_horizontal.icon.js.map